const breakpoints = require('./breakpoints');

const viewportWidth = {
    mobile: { maxWidth: breakpoints.md - 1, minWidth: 320 },
    tablet: { maxWidth: breakpoints.ls - 1, minWidth: breakpoints.md },
    landscape: { maxWidth: breakpoints.dp - 1, minWidth: breakpoints.ls },
    desktop: { maxWidth: Infinity, minWidth: breakpoints.ls },
};

/**
 * Get Layout Mode
 * @returns {string} mode
 */
function getLayoutMode() {
    // to determine layout width should be used window property "innerWidth",
    // because it contains window width including scrollbars, which meets the value of width in mediaqueries in CSS
    var windowWidth = window.innerWidth;
    var modeName = '';
    for (var mode in viewportWidth) { // eslint-disable-line
        if (windowWidth >= viewportWidth[mode].minWidth && windowWidth <= viewportWidth[mode].maxWidth) {
            modeName = mode;
        }
    }

    return modeName;
}

const layout = {
    viewPorts: viewportWidth,
    isMobile: function () {
        return window.matchMedia('(max-width: ' + (viewportWidth.mobile.maxWidth) + 'px)').matches;
    },
    isTablet: function () {
        return window.matchMedia('(max-width: ' + (viewportWidth.tablet.maxWidth) + 'px)').matches
            && window.matchMedia('(min-width: ' + (viewportWidth.tablet.minWidth) + 'px)').matches;
    },
    isDesktop: function () {
        return window.matchMedia('(min-width: ' + (viewportWidth.desktop.minWidth) + 'px)').matches;
    },
    isLandscape: function () {
        return window.matchMedia('(max-width: ' + (viewportWidth.landscape.maxWidth) + 'px)').matches
            && window.matchMedia('(min-width: ' + (viewportWidth.landscape.minWidth) + 'px)').matches;
    },
    getMode: getLayoutMode
};

module.exports = layout;
